<template>
  <q-page padding>
    <PageHeader
      :backRoute="{ name: 'ferramentaria-lista-reserva' }"
      backBehavior="route"
    >
      <template #title>
        Detalhe Reserva: #{{ dadosReserva.numeroReserva }}
      </template>
    </PageHeader>
    <div class="row col-12 q-mt-md q-gutter-sm text-brand-5 text-weight-bold">
      <div class="col-md-2 col-xs-6">
        <div class="texto-titulo-input">Unidade</div>
        <q-input
          v-model="dadosReserva.unidadeId"
          dense
          outlined
          class="input"
          disable
          bg-color="brand-7"
        />
      </div>
      <div class="col-md-2 col-xs-5">
        <div class="texto-titulo-input">Nº Reserva</div>
        <q-input
          v-model="dadosReserva.numeroReserva"
          dense
          class="input"
          outlined
          disable
          bg-color="brand-7"
        />
      </div>
      <div class="col-md-2 col-xs-6">
        <div class="texto-titulo-input">Data de Criação</div>
        <q-input
          v-model="dadosReserva.criadoEm"
          dense
          outlined
          disable
          class="input"
          bg-color="brand-7"
        />
      </div>
      <div class="col-md-2 col-xs-5">
        <div class="texto-titulo-input">Nome Solicitante</div>
        <q-input
          v-model="dadosReserva.solicitanteNome"
          dense
          outlined
          disable
          class="input"
          bg-color="brand-7"
        />
      </div>
      <div class="col-md-2 col-xs-6">
        <div class="texto-titulo-input">Matricula Solicitante</div>
        <q-input
          v-model="dadosReserva.solicitanteId"
          dense
          outlined
          disable
          class="input"
          bg-color="brand-7"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        :columns="columns"
        :rows="dadosReserva?.itens"
        :hide-bottom="!dadosReserva?.itens?.length == 0"
        dense
        no-data-label="Nenhuma reserva criada"
        table-header-class="bg-accent text-weight-bold"
        flat
        :class="{ 'my-sticky-dynamic': !mobile }"
        :rows-per-page-options="[0]"
        :grid="mobile"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs row col-12">
            <q-card class="container-grid-table col-12">
              <div class="q-pa-sm">
                <div class="row col-12 items-center">
                  <div class="col-8">
                    <div class="row col-12">
                      <strong class="q-mr-xs">Código:</strong>
                      <span> {{ props.row?.detalheItem?.codigo }}</span>
                    </div>
                    <div class="row col-12">
                      <strong class="q-mr-xs">Descrição:</strong>
                      <span> {{ props.row?.detalheItem?.nome }}</span>
                    </div>
                    <div class="row col-12">
                      <strong class="q-mr-xs">Grupo:</strong>
                      <span>
                        {{ props.row?.detalheItem?.catalogoGrupo.nome }}</span
                      >
                    </div>
                    <div class="row col-12">
                      <strong class="q-mr-xs">Subgrupo:</strong>
                      <span>
                        {{
                          props.row?.detalheItem?.catalogoSubGrupo.nome
                        }}</span
                      >
                    </div>
                  </div>
                  <div class="col">
                    <div class="row col-12 justify-end items-center">
                      <q-btn
                        color="secondary"
                        icon="article"
                        round
                        :disable="
                          autenticacao || dadosReserva.finalizadoEm != null
                        "
                        flat
                        @click="
                          (modalAtivos = true),
                            (itemUuid = props.row.catalogoItemUuid)
                        "
                      />
                      <q-btn
                        color="red"
                        icon="delete"
                        round
                        :disable="
                          autenticacao || dadosReserva.finalizadoEm != null
                        "
                        flat
                        @click="
                          (confirm = true),
                            (itemUuid = props.row.catalogoItemUuid)
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </q-card>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td>
              {{ props.row?.detalheItem?.codigo }}
            </q-td>
            <q-td>
              {{ props.row?.detalheItem?.nome }}
            </q-td>
            <q-td>
              {{ props.row?.detalheItem?.catalogoGrupo?.nome }}
            </q-td>
            <q-td>
              {{ props.row?.detalheItem?.catalogoSubGrupo?.nome }}
            </q-td>
            <q-td>
              <q-btn
                color="secondary"
                icon="article"
                round
                :disable="autenticacao || dadosReserva.finalizadoEm != null"
                flat
                @click="
                  (modalAtivos = true), (itemUuid = props.row.catalogoItemUuid)
                "
              />
            </q-td>
            <q-td>
              <q-btn
                color="red"
                icon="delete"
                round
                flat
                :disable="autenticacao || dadosReserva.finalizadoEm != null"
                @click="
                  (confirm = true), (itemUuid = props.row.catalogoItemUuid)
                "
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <div class="q-mt-xl" v-if="selected.length > 0">
      <div class="row col-12 justify-between items-center q-mb-sm">
        <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
          {{
            dadosReserva?.finalizadoEm != null
              ? "Ativos Retirados"
              : "Ativos Selecionados"
          }}
        </div>
      </div>
      <q-table
        :columns="columnsAtivosSelecionados"
        :rows="selected"
        hide-bottom
        no-data-label="Nenhum ativo encontrado"
        dense
        table-header-class="bg-accent text-weight-bold"
        flat
        row-key="ativoUuid"
        :class="{ 'my-sticky-dynamic': !mobile }"
        :rows-per-page-options="[0]"
        :grid="mobile"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs row col-12">
            <q-card class="container-grid-table col-12">
              <div class="q-pa-sm">
                <div class="row col-12 items-center">
                  <div class="col-7">
                    <div class="row col-12">
                      <strong class="q-mr-xs">Código:</strong>
                      <span>
                        {{
                          props.row?.catalogoItemCodigo ||
                          props.row.codigo ||
                          props.row.catalogoItem.codigo
                        }}</span
                      >
                    </div>
                    <div class="row col-12">
                      <strong class="q-mr-xs">Descrição:</strong>
                      <span>
                        {{
                          props.row?.catalogoItemNome ||
                          props.row.nome ||
                          props.row.catalogoItem.nome
                        }}</span
                      >
                    </div>
                    <div class="row col-12">
                      <strong class="q-mr-xs">Valor:</strong>
                      <span> {{ props.row.valor }}</span>
                    </div>
                    <div class="row col-12">
                      <strong class="q-mr-xs">Patrimônio:</strong>
                      <span> {{ props.row.patrimonio }}</span>
                    </div>
                    <div class="row col-12">
                      <strong class="q-mr-xs">Grupo:</strong>
                      <span>
                        {{
                          props.row.grupo ||
                          props.row.catalogoGrupo ||
                          props.row.catalogoItem?.catalogoGrupo?.nome
                        }}</span
                      >
                    </div>
                    <div class="row col-12">
                      <strong class="q-mr-xs">Subgrupo:</strong>
                      <span>
                        {{
                          props.row.subgrupo ||
                          props.row.catalogoSubGrupo ||
                          props.row.catalogoItem?.catalogoSubGrupo?.nome
                        }}</span
                      >
                    </div>
                  </div>
                  <div class="col">
                    <div class="row col-12 justify-end items-center">
                      <div class="q-mr-sm">
                        <div
                          style="
                            border: 1px solid #707070;
                            height: 60px;
                            width: 60px;
                            border-radius: 5px;
                          "
                        >
                          <q-img
                            v-if="props.row.urlImagem"
                            fit="contain"
                            height="100%"
                            width="95%"
                            :src="props.row.urlImagem"
                          />
                          <q-img
                            v-else
                            fit="contain"
                            height="100%"
                            width="95%"
                            src="../../../assets/semImagem.jpg"
                          />
                        </div>
                      </div>
                      <div class="q-ml-sm">
                        <q-btn
                          color="red"
                          icon="delete"
                          :disable="
                            autenticacao || dadosReserva.finalizadoEm != null
                          "
                          round
                          flat
                          @click="removerAtivoSelecionado(props.row.ativoUuid)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </q-card>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td>
              {{
                props.row?.catalogoItemCodigo ||
                props.row.codigo ||
                props.row.catalogoItem?.codigo
              }}
            </q-td>
            <q-td>
              {{
                props.row?.catalogoItemNome ||
                props.row.nome ||
                props.row.catalogoItem?.nome
              }}
            </q-td>
            <q-td>
              {{ props.row.preco }}
            </q-td>
            <q-td>
              {{ props.row.patrimonio }}
            </q-td>
            <q-td>
              {{
                props.row.grupo?.nome ||
                props.row.catalogoGrupo ||
                props.row.catalogoItem?.catalogoGrupo?.nome
              }}
            </q-td>
            <q-td>
              {{
                props.row.subgrupo?.nome ||
                props.row.catalogoSubGrupo ||
                props.row.catalogoItem?.catalogoSubGrupo?.nome
              }}
            </q-td>
            <q-td>
              <q-btn
                color="red"
                icon="delete"
                :disable="autenticacao || dadosReserva.finalizadoEm != null"
                round
                flat
                @click="removerAtivoSelecionado(props.row.ativoUuid)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <ComponenteChecklistAcessorio
      v-if="dadosReserva?.finalizadoEm == null"
      :etapa="'emprestimo'"
      :verificar="validarRespostas"
      :arrayRespostas="selected"
      :respostas="respostas"
      @enviarValidacaoRespostas="criarRetirada"
    />
    <ComponenteAutenticacao
      v-if="dadosReserva?.finalizadoEm == null"
      :etapa="'emprestimo'"
      :autenticacao="autenticacao"
      :resetar="resetarAutenticacao"
      :usuario="dadosRequisitante"
      @resetarAutenticacao="resetVariaveis"
      @iniciarAutenticacao="verificarRespostas"
      @enviarAutenticacaoSolicitante="receberAutenticacaoSolicitante"
      @enviarAutenticacaoAlmoxarife="receberAutenticacaoAlmoxarife"
      @atualizarTemplates="atualizarTemplatesBiometria"
      @finalizarProcesso="finalizarReserva"
      @enviarSetupConfiguracao="receberSetupConfiguracao"
    />
    <q-dialog v-model="confirm" persistent>
      <q-card
        class="q-pa-sm container-modal-excluir text-brand-5 text-weight-bolder q-pa-xl"
      >
        <q-card-section class="row col-12 justify-center">
          <span class="texto-excluir-pai"
            >TEM CERTEZA QUE DESEJA REMOVER ESSE ITEM?</span
          >
          <span class="texto-excluir-filho text-brand-5 q-mt-md q-mb-lg">
            Ao clicar em Excluir você estará deletando por definitivo o item da
            reserva.</span
          >
        </q-card-section>

        <div class="row col-12 justify-center">
          <q-btn
            no-caps
            label="Excluir"
            color="positive"
            v-close-popup
            class="btn-excluir"
            icon="check_circle_outline"
            @click="excluirItem()"
          />
          <q-btn
            icon="cancel"
            no-caps
            label="Cancelar"
            color="negative"
            class="btn-excluir q-ml-md"
            v-close-popup
          />
        </div>
      </q-card>
    </q-dialog>
    <q-dialog v-model="modalAtivos">
      <q-card class="modal-ativos">
        <q-card-section>
          <div class="text-h6 text-brand-5 text-weight-bold">
            Lista de Ativos
          </div>
        </q-card-section>

        <q-card-section style="height: 450px" class="scrool">
          <div class="q-mb-sm">
            <ComponenteFiltros
              :codigo="true"
              :classCodigo="'col-md col-xs-12'"
              :descricao="true"
              :classDescricao="'col-md col-xs-12'"
              :classGrupo="'col-md col-xs-12'"
              :subgrupo="true"
              :classSubgrupo="'col-md col-xs-12'"
              :patrimonio="true"
              :classPatrimonio="'col-md col-xs-12'"
              :listarTodos="true"
              @enviarFiltro="receberFiltro"
            />
          </div>
          <q-linear-progress v-if="loadingAtivos" indeterminate size="3px" />
          <div>
            <q-table
              :rows="ativosLista"
              flat
              :columns="columnsAtivos"
              selection="multiple"
              v-model:selected="selected"
              dense
              row-key="ativoUuid"
              :rows-per-page-options="[0]"
              no-data-label="Nenhum ativo encontrado."
              class="my-sticky-dynamic-ativo"
              :hide-bottom="!ativosLista.length == 0"
            >
              <template v-slot:header="props">
                <q-tr :props="props">
                  <q-th
                    class="text-weight-bolder"
                    v-for="col in props.cols"
                    :key="col.name"
                    :props="props"
                  >
                    {{ col.label }}
                  </q-th>
                </q-tr>
              </template>
              <template v-slot:body="props">
                <q-tr class="text-brand-5 text-weight-bold">
                  <q-td>
                    <q-btn
                      round
                      size="10px"
                      :icon="props.selected ? 'close' : 'add'"
                      :color="props.selected ? 'red' : 'secondary'"
                      @click="props.selected = !props.selected"
                    />
                  </q-td>
                  <q-td>
                    {{
                      props.row?.catalogoItemCodigo ||
                      props.row.codigo ||
                      props.row.catalogoItem?.codigo
                    }}
                  </q-td>
                  <q-td>
                    {{
                      props.row?.catalogoItemNome ||
                      props.row.nome ||
                      props.row.catalogoItem?.nome
                    }}
                  </q-td>
                  <q-td>
                    {{ props.row.preco }}
                  </q-td>
                  <q-td>
                    {{ props.row.patrimonio }}
                  </q-td>
                  <q-td>
                    {{
                      props.row.grupo?.nome ||
                      props.row.catalogoGrupo ||
                      props.row.catalogoItem?.catalogoGrupo?.nome
                    }}
                  </q-td>
                  <q-td>
                    {{
                      props.row.subgrupo?.nome ||
                      props.row.catalogoSubGrupo ||
                      props.row.catalogoItem?.catalogoSubGrupo?.nome
                    }}
                  </q-td>
                </q-tr>
              </template>
            </q-table>
            <div
              v-if="ativosLista.length > 0"
              class="row justify-center q-mt-md"
            >
              <q-pagination
                :disable="disableAtivoLista"
                v-model="pagination.page"
                color="brand-5"
                active-color="secondary"
                active-text-color="white"
                :max="pagesNumber"
                :max-pages="5"
                :boundary-numbers="false"
                :direction-links="true"
                :size="mobile ? 'md' : 'sm'"
              />
            </div>
          </div>
        </q-card-section>
        <q-card-section class="row col-12 q-gutter-sm justify-end">
          <!-- <q-btn
              @click="selected = []"
              label="Cancelar"
              color="red"
              icon="cancel"
              no-caps
              v-close-popup
            /> -->
          <q-btn
            label="Salvar"
            icon="done"
            no-caps
            color="positive"
            v-close-popup
          />
        </q-card-section>
      </q-card>
    </q-dialog>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </q-page>
</template>

<script>
import { useStore } from "vuex";
import { onMounted, ref, watch, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useQuasar } from "quasar";

import ComponenteAutenticacao from "../components/ComponenteAutenticacao.vue";
import ComponenteChecklistAcessorio from "../components/ComponenteChecklistAcessorio.vue";
import ComponenteFiltros from "../components/ComponenteFiltros.vue";
import PageHeader from "../../../components/PageHeader.vue";

const columns = [
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descrição",
    label: "Descrição",
    align: "left",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
  },
  {
    name: "subgrupo",
    label: "Subgrupo",
    align: "left",
  },
  {
    name: "ativos",
    label: "Ativos",
    align: "left",
  },
  {
    name: "excluir",
    label: "Excluir",
    align: "left",
  },
];

const columnsAtivos = [
  {
    name: "selecionar",
    label: "",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descrição",
    label: "Descrição",
    align: "left",
  },
  {
    name: "valor",
    label: "Valor",
    align: "left",
  },
  {
    name: "patrimonio",
    label: "Patrimônio",
    align: "left",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
  },
  {
    name: "subgrupo",
    label: "Subgrupo",
    align: "left",
  },
];
const columnsAtivosSelecionados = [
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descrição",
    label: "Descrição",
    align: "left",
  },
  {
    name: "valor",
    label: "Valor",
    align: "left",
  },
  {
    name: "patrimonio",
    label: "Patrimônio",
    align: "left",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
  },
  {
    name: "subgrupo",
    label: "Subgrupo",
    align: "left",
  },
  {
    name: "remover",
    label: "Remover",
    align: "left",
  },
];
export default {
  components: {
    ComponenteAutenticacao,
    ComponenteChecklistAcessorio,
    ComponenteFiltros,
    PageHeader,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const quasar = useQuasar();

    const dadosReserva = ref({});
    const rightDrawerOpen = ref(false);
    const reservaId = route.params.reservaId;
    const ativosLista = ref([]);
    const ativosItensSelecionados = ref([]);
    const selected = ref([]);
    let confirm = ref(false);
    let autenticacao = ref(false);
    const itemUuid = ref("");
    let loading = ref(false);
    let loadingAtivos = ref(false);
    const autenticacaoSolicitante = ref({
      authType: "",
      authContent: "",
    });
    const autenticacaoAlmoxarife = ref({
      authType: "",
      authContent: "",
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 6,
    });
    const respostas = ref({ responderCheckLists: "", responderAcessorios: "" });
    const dadosRequisitante = ref({});
    const resetarAutenticacao = ref(0);
    const validarRespostas = ref(0);
    let disableAtivoLista = ref(false);
    let modalAtivos = ref(false);
    const filtros = ref({});
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }
    const detalharReserva = async () => {
      await store.state.org.unidadeData.id;
      loading.value = true;
      if (
        store.state.org.unidadeData.id === "" ||
        store.state.org.unidadeData.id == undefined
      ) {
        return;
      }
      try {
        const response = await store.dispatch(
          "ferramentaria/listarReservaCriada",
          {
            unidadeId: store.state.org.unidadeData.id || undefined,
            reservaUuid: reservaId,
          }
        );
        dadosReserva.value = { ...response.data.resultado.dados[0] };
        dadosReserva.value.criadoEm = `${response.data.resultado?.dados[0]?.criadoEm
          .split(" ")[0]
          .split("-")
          .reverse()
          .join("/")} ${
          response.data.resultado?.dados[0]?.criadoEm.split(" ")[1]
        }`;
        if (dadosReserva.value.finalizadoEm != null) {
          listarAtivoRetirado();
        }
        loading.value = false;
      } catch (error) {
        console.log(error);
        loading.value = false;
      }
    };

    const listarAtivoItem = async (page = 1, perPage = 10) => {
      loadingAtivos.value = true;
      disableAtivoLista.value = true;
      try {
        const response = await store.dispatch("ferramentaria/listarAtivo", {
          catalogoItemUuid:
            filtros.value?.listarTodos == true ? "" : itemUuid.value,
          unidadeId: store.state.org.unidadeData.id,
          comCheckLists: "sim",
          comAtributos: "sim",
          comAcessorios: "sim",
          status: "disponivel",
          page: page,
          perPage: perPage,
          catalogoSubGrupoUuid: filtros.value.subgrupo?.catalogoSubGrupoUuid,
          codigo: filtros.value?.codigo,
          nome: filtros.value?.descricao,
          nomeGrupo: filtros.value?.grupo?.nome,
          nomeSubgrupo: filtros.value?.subgrupo?.nome,
        });
        ativosLista.value = response.response.data.resultado.dados;
        pagination.value.page = response.response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.response.data.resultado.total;
        pagination.value.rowsPerPage = response.response.data.resultado.perPage;
        loadingAtivos.value = false;
        disableAtivoLista.value = false;
      } catch (error) {
        console.log(error);
        loadingAtivos.value = false;
        disableAtivoLista.value = false;
      }
    };

    const adicionarRemoverLinha = (linha) => {
      if (ativosItensSelecionados.value.indexOf(linha.ativoUuid) > -1) {
        selected.value.push(linha);
      } else {
        let index = selected.value.findIndex(
          (v) => v.ativoUuid === linha.ativoUuid
        );
        selected.value.splice(index, 1);
      }
    };

    const removerAtivoSelecionado = (ativoUuid) => {
      let indexAtivosSelecionado =
        ativosItensSelecionados.value.indexOf(ativoUuid);
      ativosItensSelecionados.value.splice(indexAtivosSelecionado, 1);

      let indexSelectedAtivosSelecionado = selected.value.findIndex(
        (v) => v.ativoUuid === ativoUuid
      );
      selected.value.splice(indexSelectedAtivosSelecionado, 1);
    };

    const finalizarReserva = async () => {
      try {
        let ativos = [];
        selected.value.forEach((ativo) => {
          ativos.push({
            ativoUuid: ativo.ativoUuid,
            checkLists:
              ativo?.checkLists?.length > 0
                ? verificarChecklist(ativo?.checkLists)
                : undefined,
            acessorios:
              ativo?.acessorios?.length > 0
                ? verificarAcessorio(ativo?.acessorios)
                : undefined,
          });
        });
        await store.dispatch("ferramentaria/criarEmprestimo", {
          unidadeId: store.state.org.unidadeData.id,
          reservaUuid: reservaId,
          almoxId: store.state.autenticacao.usuarioLogado.id,
          solicitanteId: dadosRequisitante.value.id,
          solicitanteAuthType: autenticacaoSolicitante.value.authType,
          solicitanteAuthContent: autenticacaoSolicitante.value.authContent,
          solicitanteNome: dadosRequisitante.value.nome,
          almoxAuthType: autenticacaoAlmoxarife.value.authType,
          almoxAuthContent: autenticacaoAlmoxarife.value.authContent,
          almoxNome: store.state.autenticacao.usuarioLogado.nome,
          observacao: "",
          ativos: ativos,
        });
        quasar.notify({
          message: "Retirada feita com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        resetVariaveis();
        router.push({ name: "ferramentaria-lista-reserva" });
      } catch (error) {
        if (error.response?.data.erro?.detalhes?.ativos?.checkLists) {
          quasar.notify({
            message: "Responda todos os checklists.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response?.data.erro?.mensagem) {
          quasar.notify({
            message: error.response?.data.erro?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response?.data.erros?.mensagem) {
          quasar.notify({
            message: error.response?.data.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const criarRetirada = () => {
      if (selected.value.length == 0) {
        quasar.notify({
          message: "Selecione ao menos um ativo para finalizar a reserva.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      autenticacao.value = true;
    };

    const excluirItem = async () => {
      try {
        await store.dispatch("ferramentaria/excluirItemReserva", {
          catalogoItemUuid: itemUuid.value,
          reservaUuid: reservaId,
        });
        detalharReserva();
      } catch (error) {
        if (error.response?.data.erros?.mensagem) {
          quasar.notify({
            message: error.response?.data.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const receberAutenticacaoSolicitante = (value) => {
      autenticacaoSolicitante.value = value;
    };

    const verificarRespostas = () => {
      validarRespostas.value++;
    };

    const atualizarTemplatesBiometria = async () => {
      try {
        await store.dispatch("user/atualizarTemplatesBiometria");
        listarFuncionarioEspecifico();
      } catch (error) {
        console.log(error);
      }
    };

    const listarFuncionarioEspecifico = async () => {
      if (dadosReserva.value.solicitanteId == undefined) {
        return;
      }
      try {
        const response = await store.dispatch(
          "ferramentaria/listarFuncionarios",
          {
            unidadeId: store.state.org.unidadeData.id,
            per_page: 100,
            search: dadosReserva.value.solicitanteId,
            page: 1,
          }
        );
        let array = response.funcionarios.filter(
          (funcionario) => funcionario.id == dadosReserva.value.solicitanteId
        );
        dadosRequisitante.value = { ...array[0] };
      } catch (error) {
        console.error(error);
      }
    };

    const verificarChecklist = (checklist) => {
      let valido = checklist.every(
        (value) => value.resposta === "sim" || value.resposta === "nao"
      );
      if (!valido) {
        return undefined;
      }
      let array = [];
      checklist.forEach((value) => {
        array.push({
          checkListUuid: value.checkListUuid,
          resposta: value.resposta,
        });
      });
      return array;
    };

    const verificarAcessorio = (acessorios) => {
      let valido = acessorios.every(
        (value) => value.resposta === "sim" || value.resposta === "nao"
      );
      if (!valido) {
        return undefined;
      }
      let array = [];
      acessorios.forEach((value) => {
        array.push({
          acessorioUuid: value.uuid,
          resposta: value.resposta,
        });
      });
      return array;
    };

    const receberAutenticacaoAlmoxarife = (value) => {
      autenticacaoAlmoxarife.value = value;
    };

    const receberSetupConfiguracao = (value) => {
      respostas.value = value;
    };

    const receberFiltro = (value) => {
      filtros.value = value;
      listarAtivoItem();
    };

    const resetVariaveis = () => {
      ativosItensSelecionados.value = [];
      selected.value = [];
      autenticacao.value = false;
      autenticacaoSolicitante.value = {
        authType: "",
        authContent: "",
      };
      autenticacaoAlmoxarife.value = {
        authType: "",
        authContent: "",
      };
    };

    const listarAtivoRetirado = () => {
      dadosReserva.value.itens.forEach((value) => {
        value.ativosRetirados.forEach((ativo) => selected.value.push(ativo));
      });
    };

    watch(
      () => modalAtivos.value,
      () => {
        if (modalAtivos.value === false) {
          ativosLista.value = [];
          return;
        }
        listarAtivoItem();
      }
    );

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        detalharReserva();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarAtivoItem(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => dadosReserva.value.solicitanteId,
      () => {
        listarFuncionarioEspecifico();
      }
    );

    onMounted(() => {
      detalharReserva();
      listarFuncionarioEspecifico();
    });

    return {
      reservaId,
      dadosReserva,
      columns,
      rightDrawerOpen,
      listarAtivoItem,
      columnsAtivos,
      ativosLista,
      ativosItensSelecionados,
      adicionarRemoverLinha,
      selected,
      removerAtivoSelecionado,
      finalizarReserva,
      excluirItem,
      confirm,
      itemUuid,
      mobile,
      criarRetirada,
      autenticacao,
      loading,
      loadingAtivos,
      verificarChecklist,
      receberAutenticacaoAlmoxarife,
      receberSetupConfiguracao,
      receberAutenticacaoSolicitante,
      autenticacaoAlmoxarife,
      autenticacaoSolicitante,
      respostas,
      disableAtivoLista,
      verificarAcessorio,
      atualizarTemplatesBiometria,
      dadosRequisitante,
      resetVariaveis,
      resetarAutenticacao,
      listarAtivoRetirado,
      validarRespostas,
      verificarRespostas,
      modalAtivos,
      filtros,
      columnsAtivosSelecionados,
      receberFiltro,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
tbody tr .coluna-btn {
  width: 120px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
.my-sticky-dynamic-ativo {
  max-height: 300px;
}
a {
  text-decoration: none;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.card {
  border: 1px solid #707070;
  border-radius: 5px;
}
.text-grid-table {
  font-size: 14px;
}
.texto-titulo {
  font-size: 20px;
}
.icon-voltar {
  font-size: 25px;
}
.container-link-voltar {
  margin-right: 10px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.titulo-tabela {
  font-size: 18px;
}
.texto-titulo-modal {
  font-size: 16px;
}
.container-modal-excluir {
  width: 590px;
}
.texto-excluir-pai {
  text-align: center;
  text-justify: inter-word;
  font-size: 23px;
  font-weight: bold;
  color: black;
}
.texto-excluir-filho {
  text-align: center;
  text-justify: inter-word;
  font-size: 15px;
}
.btn-excluir {
  font-size: 16px;
  padding: 0px 25px;
}
.img {
  width: 60px;
  height: 60px;
}
.titulo-item-texto {
  font-size: 18px;
}
.subtitulo-item-texto {
  font-size: 16px;
}
.titulo-pergunta-item-texto {
  font-size: 15px;
  word-break: break-all;
}
.borda-resposta {
  border-top: 2px solid #707070;
  border-bottom: 2px solid #707070;
}
.mobile {
  display: none;
}
.borda-top {
  border-top: 2px solid #707070;
}
.borda-bottom {
  border-bottom: 2px solid #707070;
}
.modal-ativos {
  min-width: 1400px;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 100%;
    height: 85%;
    overflow: hidden;
    top: 103px;
    width: 340px;
  }
  .modal-ativos {
    min-width: 100%;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .texto-titulo-modal {
    font-size: 14px;
  }
  .container-btn {
    justify-content: center;
    margin: 20px 9px 15px 0px;
  }
  .btn {
    font-size: 13px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .container-modal-excluir {
    width: 100%;
    height: 250px;
    padding: 10px 10px 0px 10px;
    margin: 0px;
    border-radius: 10px;
  }
  .texto-excluir-pai {
    font-size: 17px;
  }
  .texto-excluir-filho {
    font-size: 14px;
  }
  .btn-excluir {
    font-size: 14px;
  }
  .img {
    width: 50px;
    height: 50px;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .titulo-item-texto {
    font-size: 14px;
  }
  .subtitulo-item-texto {
    font-size: 13px;
  }
  .titulo-pergunta-item-texto {
    font-size: 12px;
  }
  .radio {
    font-size: 12px;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
</style>
